export const SET_APP_MOBILE = 'setMobile'
export const SET_APP_LANGUAGES = 'setLanguages'
export const SET_APP_EDUCATION_LEVELS = 'setEducationLevels'
export const TOGGLE_DARKMODE = 'toggleDarkmode'